import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc constant
     * @name INCLUDE
     * @memberof app
     *
     * @description
     * URLs to the pages in the includes folder.
     *
     * @author flzemke.btc
     */
    angular.module('app').constant('INCLUDE', {
        QUANTITY_VALIDATION_ERRORS:
            'app/includes/quantity-validation-errors.html'
    });
})();
